import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheDynestateStandard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const standards = [{
    title: "Strategic Underwriting",
    content: "We employ a rigorous, data-driven approach to assess risk and unlock value. Our underwriting process goes beyond surface-level metrics, analyzing market liquidity, asset durability, and sponsor track record to ensure every deal is structured for maximum stability and risk-adjusted return."
  }, {
    title: "Capital Velocity",
    content: "In high-stakes real estate and business finance, speed is currency. Our streamlined internal processes and deep capital reserves allow us to close complex transactions with the certainty of execution that institutional borrowers demand, often when others are still deliberating."
  }, {
    title: "Institutional Integrity",
    content: "Built on a foundation of transparency and trust, we operate with the discipline of a global financial institution. We prioritize long-term partnerships over short-term gains, ensuring that our interests remain aligned with those of our borrowers and capital partners throughout the lifecycle of every loan."
  }];
  return <section id="the-dynestate-standard" className="dark bg-background text-foreground w-full min-h-screen flex flex-col lg:flex-row overflow-hidden">
      {}
      <div className="relative w-full lg:w-[60%] min-h-[50vh] lg:min-h-auto bg-muted overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562991/img/dynestate_architectural_vertical.png)] grayscale contrast-125" />
        {}
        <div className="absolute inset-0 bg-black/20 mix-blend-overlay" />
        <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent lg:hidden" />
      </div>

      {}
      <div className="w-full lg:w-[40%] flex flex-col justify-center p-8 lg:p-20 xl:p-24 relative border-l border-border/50">
        <div ref={ref} className={cn("transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight mb-12 text-foreground">The DynEstate Standard</h2>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {standards.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border/40 last:border-0 px-0" data-index={i}>
                <AccordionTrigger className="text-xl md:text-2xl font-medium text-muted-foreground hover:text-foreground transition-colors py-6 font-serif tracking-wide decoration-transparent hover:underline-offset-4">
                  {item.title}
                </AccordionTrigger>
                <AccordionContent className="text-base md:text-lg leading-relaxed text-foreground/90 pb-6 font-sans font-light">
                  {item.content}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}